var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.625 278.625L374.625 406.625C362.118 419.132 341.868 419.118 329.375 406.625C316.875 394.125 316.875 373.875 329.375 361.375L402.75 288H32C14.312 288 0 273.688 0 256S14.312 224 32 224H402.75L329.375 150.625C316.875 138.125 316.875 117.875 329.375 105.375S362.125 92.875 374.625 105.375L502.625 233.375C515.125 245.875 515.125 266.125 502.625 278.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLong);
export default __webpack_public_path__ + "static/media/arrow-right-long.f7c99b6a228e02bae5cd77f38de8bfb6.svg";
export { ForwardRef as ReactComponent };